export const SET_LOAD_AFTER_SALE_STATE = 'SET_LOAD_AFTER_SALE_STATE';

export default function setLoadAferSale(payload) {
  return {
    type: SET_LOAD_AFTER_SALE_STATE,
    payload,
  };
}
